module.exports = __webpack_public_path__ + "static/media/a1bcfb39-793e-4b6e-a05a-4e7b82ebbfc4.41d16957.jpg";